import { withStyles, withTheme } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import React, {memo} from "react";
import { compose } from "recompose";
import Tooltip from "../../../components/common/StyledToolTip";
import { PICKUP_MANAGEMENT_MODES } from "../../../components/modules/Dispatch/RouteExecution/Pickups/PickupManagement/constants";
import styles from "./styles";

class VoidPickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
    };
    this.isCompleted = false;
    this.isVoided = false;
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeVoidPickupStatus,
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeVoidPickupStatus,
    );
  }

  changeVoidPickupStatus = ({ selectedPickups }) => {
    const { isCompleted, isVoided } = selectedPickups[0] ?? {};
    this.isCompleted = isCompleted;
    this.isVoided = isVoided;
    const isEnabled = selectedPickups.length === 1 && !(this.isCompleted || this.isVoided);
    if (this.state.enable !== isEnabled) {
      this.setState({
        enable: isEnabled,
      });
    }
  };

  getTooltipMessage = () => {
    if (this.state.enable) {
      return "Click to Void Pickup";
    } else if (this.isCompleted) {
      return "Pickup is already completed";
    } else if (this.isVoided) {
      return "Pickup is already voided";
    }
    return "Select a single pickup to void";
  };

  onVoidPickupEvent = () => {
    if (this.state.enable) {
      this.props.eventHub.emit("pickupManagement", {
        action: PICKUP_MANAGEMENT_MODES.VOID_PICKUP,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { enable } = this.state;
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${enable ? classes.enabledIcon : classes.disableIcon}`}
        onClick={this.onVoidPickupEvent}
      >
        <Tooltip title={this.getTooltipMessage()}>
          <DeleteOutlineIcon />
        </Tooltip>
      </div>
    );
  }
}

export default compose(withStyles(styles), withTheme())(memo(VoidPickup));
